import { Component, Input } from "@angular/core";

import { Observable } from "rxjs/Observable";
import { ITranslations } from "../../../../_models/ITranslations";
import { TranslationService } from "../../../../_services/translation.service";
import { ChildAbstractModel } from "../../../../_models/child-abstract-model";

@Component({
  selector: "discount-management-brief-results-view",
  template: ` <div class="brother-attribution-brief-results" [dir]="'ltr'">
    <div *ngIf="_child.nest" class="column">
      <span class="limit-text-width " [dir]="'rtl'">
        {{ _child.nest }}
      </span>
    </div>
    <div *ngIf="_child.israeliId" class="column">
      {{ _child.israeliId }}
    </div>
    <div *ngIf="_child.layer && !hideLayer" class="column">
      <span class=" " [dir]="'rtl'">
        {{ (translations$ | async).layer_field }} {{ _child.layer }}
      </span>
    </div>
  </div>`,
  styleUrls: ["discount-management-brief-results-view.component.scss"],
})
export class DiscountManagementBriefResultsViewComponent {
  @Input("hideLayer") public hideLayer: boolean = false;
  public translations$: Observable<ITranslations>;

  constructor(private translationService: TranslationService) {
    this.translations$ = this.translationService.translations;
  }

  public _child: ChildAbstractModel;

  @Input() set child(child: ChildAbstractModel) {
    this._child = child;
  }
}



// WEBPACK FOOTER //
// ./src/app/admin/discounts/discount-management-page/discount-management-brief-results-view/discount-management-brief-results-view.component.ts